<template>
  <div class="vx-row">
    <vx-card>
      <template slot="actions">
        <div class="flex float-right">
          <div class="con-btns-user flex items-center justify-between">
            <div class="flex mb-4">
              <vs-button v-can="'create-standard-action'" @click="onClickCreateLocation" class="mr-4" color="primary"
                type="filled">New</vs-button>
            </div>
          </div>
        </div>
      </template>
      <div slot="no-body" class="mt-4">

        <vs-table  :max-items="(meta.pageSize) ? meta.pageSize : 20" id="users-list" :data="users_list"
          @sort="handleSort" :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

          <template slot="thead">
            <vs-th width="30%" sort-key="name">Name</vs-th>
            <vs-th width="30%" sort-key="email">Action</vs-th>
            <vs-th width="30%" sort-key="contact_1">Hazard</vs-th>
            <vs-th width="10%">ACTION</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data" class="cursor-pointer" @click.native="onClickUpdate(data[indextr])">


              <vs-td :data="data[indextr].Name">
                {{ data[indextr].Name }}
              </vs-td>

              <vs-td>
                {{ data[indextr].Action | truncate(150) }}
              </vs-td>

              <vs-td>
                {{ data[indextr].Hazard | truncate(150) }}
              </vs-td>

              <vs-td>
                <div class="vx-row">
                  <vx-tooltip v-can="'update-standard-action'" class="mr-2" text="Update/View Contact" position="top">
                    <vs-button @click.stop="onClickUpdate(data[indextr])" size="small" color="primary" type="border"
                      icon-pack="feather" icon="icon-eye"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip v-can="'delete-standard-action'" class="mr-2" text="Delete Contact" position="top">
                    <vs-button @click.stop="onClickDeleteConfirm(data[indextr]._id)" size="small" color="danger" type="border"
                      icon-pack="feather" icon="icon-trash-2"></vs-button>
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>

        </vs-table>
        <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.pageSize ? meta.pageSize : 20"
          :max-items="perPage" description-body="Rows per page" description-connector="of" description-title="Records"
          description :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0"
          v-model="page" class="p-5">
        </vs-pagination>
      </div>
    </vx-card>
    <CreateObjectPopUp ref="createObjectPopUp" />
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const TenantRepository = RepositoryFactory.get('tenant')
const ObjectRepository = RepositoryFactory.get('object')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import CreateObjectPopUp from "@/components/popups/general/CreateObjectPopUp.vue"

import { defaultPagination, perPageList } from "@/constants/config";

export default {
  name: 'StandardActionList',
  data() {
    return {
      users_list: [],
      id: '',
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
    }
  },
  mounted() {
    
  },
  components: {
    CreateObjectPopUp
  },
  methods: {
    async refreshData() {
      await this.fetchUsersList()
    },
    async fetchUsersList() {
      await this.$vs.loading({
        container: '#users-list',
        scale: 0.50
      });
      try {
        const { data } = (await TenantRepository.getStandardActionList(this.page, this.filterQuery, this.perPage, this.sort)).data
        this.users_list = data.data
        this.meta = data.pagination
        this.meta.last_page = Math.ceil(this.meta.totalRecords / this.meta.pageSize)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#users-list > .con-vs-loading')
    },
    async onClickCreateLocation() {
      await this.$refs.createObjectPopUp.openPopup('standardaction', 'create', {})
    },
    async onClickUpdate(data) {
      await this.$refs.createObjectPopUp.openPopup('standardaction', 'update',data)
    },
    async onClickResendEmail(email) {
      await this.$vs.loading({
        container: '#users-list',
        scale: 0.50
      });
      try {
        const { data } = await TenantRepository.resendTenantStaffUserWelcomeEmail(this.id, email)
        this.showSuccessMessage('Staff user welcome email send successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#users-list > .con-vs-loading')
    },
    async onClickDeleteConfirm(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        acceptText: 'Delete',
        text: `Are you sure you want to delete this action?`,
        accept: this.onClickDelete,
        parameters: [ id ]
      })
    },
    async onClickDelete(params) {
      await this.$vs.loading({
        container: '#users-list',
        scale: 0.50
      });
      try {
        await ObjectRepository.deleteObject('contact', params[0])
        this.fetchUsersList()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#users-list > .con-vs-loading')
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    filterQueryUpdate() {
      this.fetchUsersList()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchUsersList()
    },

    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchUsersList()
      }

    }

  },
  watch: {
    page() {
      this.fetchUsersList()
    },
    perPage() {
      this.fetchUsersList()
    }
  },
  mixins: [SuccessMessage, ErrorMessages, Filter],
}
</script>


<style scoped></style>
